module.exports = __webpack_public_path__ + "img/twelfth-man-asset2.904408d3.png";